import { atom } from "jotai";
import {
  authAtom,
  chatsAtom,
  currentChatAtom,
  errorAtom,
  loadingAtom,
  userAtom,
} from "./atoms";

// 사용자 표시명을 가져오는 derived atom
export const userDisplayNameAtom = atom((get) => {
  const user = get(userAtom);
  return user.name || "게스트";
});

// 인증 상태 derived atom
export const isAuthenticatedAtom = atom((get) => {
  const auth = get(authAtom);
  const user = get(userAtom);
  return auth.isLoggedIn && user.id !== null;
});

// 채팅 메시지 개수 derived atom
export const messageCountAtom = atom((get) => {
  const currentChat = get(currentChatAtom);
  return currentChat?.messages.length || 0;
});

// 최근 메시지 derived atom
export const lastMessageAtom = atom((get) => {
  const currentChat = get(currentChatAtom);
  const messages = currentChat?.messages || [];
  return messages.length > 0 ? messages[messages.length - 1] : null;
});

// 사용자 메시지만 필터링하는 derived atom
export const userMessagesAtom = atom((get) => {
  const currentChat = get(currentChatAtom);
  const messages = currentChat?.messages || [];
  return messages.filter((message) => message.role === "USER");
});

// 앱 상태 요약 derived atom
export const appStatusAtom = atom((get) => {
  const isLoading = get(loadingAtom);
  const error = get(errorAtom);
  const isAuthenticated = get(isAuthenticatedAtom);
  const messageCount = get(messageCountAtom);

  return {
    isLoading,
    hasError: error !== null,
    isAuthenticated,
    messageCount,
    status: isLoading ? "loading" : error ? "error" : "ready",
  };
});

// 정렬된 채팅 목록 derived atom
export const sortedChatsAtom = atom((get) => {
  const chats = get(chatsAtom);
  return [...chats].sort(
    (a, b) =>
      new Date(b.lastMessageAt).getTime() - new Date(a.lastMessageAt).getTime()
  );
});

// 현재 채팅 메시지 derived atom
export const currentChatMessagesAtom = atom((get) => {
  const currentChat = get(currentChatAtom);
  return currentChat?.messages || [];
});
